<template>
	<div class="int-pm" :class="{ 'int-pm-vertical': vertical }">
		<div
			class="int-pm-btn"
			:class="getBtnClass(true)"
			@click="vertical ? increment() : decrement()"
		>
			<slot :name="vertical ? 'increment' : 'decrement'">
				{{ vertical ? '+' : '-' }}
			</slot>
		</div>
		<div class="int-pm-value">
			<slot>{{ intValue }}</slot>
		</div>
		<div
			class="int-pm-btn"
			:class="getBtnClass(false)"
			@click="vertical ? decrement() : increment()"
		>
			<slot :name="vertical ? 'decrement' : 'increment'">
				{{ vertical ? '-' : '+' }}
			</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'vue-integer-plus-minus',
	props: {
		value: {
			default: 0,
			type: [Number, String]
		},
		min: {
			default: 0,
			type: Number
		},
		max: {
			default: undefined,
			type: Number
		},
		step: {
			default: 1,
			type: Number
		},
		vertical: {
			default: false,
			type: Boolean
		}
	},
	data () {
		return {
			intValue: 0
		}
	},
	computed: {
		canIncrement () {
			return this.max === undefined || this.intValue + this.step <= this.max
		},
		canDecrement () {
			return this.intValue - this.step >= this.min
		}
	},
	watch: {
		value: {
			handler: function (newVal, oldVal) {
				this.intValue = newVal
			}
		}
	},
	created () {
		this.intValue = this.value
		if (this.step < 1) this.step = 1
		if (this.max < this.min) this.max = undefined
	},
	methods: {
		getBtnClass (firstBtn) {
			let btnClass = 'int-pm-'
			if ((firstBtn && !this.vertical) || (!firstBtn && this.vertical)) {
				btnClass += 'decrement'
				if (!this.canDecrement) btnClass += ' disabled'
			} else {
				btnClass += 'increment'
				if (!this.canIncrement) btnClass += ' disabled'
			}
			return btnClass
		},
		increment () {
			if (this.canIncrement) {
				this.intValue = this.intValue + this.step
				// this.quantityUpdate({productId: this.productId, quantity: this.intValue})
				this.$emit('ipm-increment', this.intValue)
				this.$emit('input', this.intValue)
			}
		},
		decrement () {
			if (this.canDecrement) {
				this.intValue = this.intValue - this.step
				// this.quantityUpdate({productId: this.productId, quantity: this.intValue})
				this.$emit('ipm-decrement', this.intValue)
				this.$emit('input', this.intValue)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.int-pm {
		display: table;
		text-align: center;
		position: relative;
		div {
			display: table-cell;
			vertical-align: middle;
		}
		.int-pm-value {
			border-width: 1px 0;
			border-color: #ccc;
			border-style: solid;
			padding: 0 10px;
		}
		.int-pm-btn {
			border: 1px solid #ccc;
			background-color: #ddd;
			cursor: pointer;
			padding: 5px 10px;
			&:hover {
				background-color: #ccc;
			}
			&.disabled {
				background-color: #eee;
				color: #777;
				cursor: not-allowed;
				&:hover {
					background-color: #eee;
				}
			}
		}
		&.int-pm-vertical {
			display: inline-block;
			div {
				display: block;
			}
			.int-pm-value {
				border-width: 0 1px;
				padding: 5px 10px;
			}
		}
	}
</style>
